module.exports = __webpack_public_path__ + "static/img/home_cmp_03.6af417f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_cmp_03.png
// module id = D30n
// module chunks = 9